import {
    AUTH_HOST,
    SUMFS_HOST,
    getEnvName
} from '@/config'
import request from '@/service/apiConfig/request'
const originSumfsHost = SUMFS_HOST[getEnvName()]

/** 
 * @description PC选品库条件搜索商品
 */
export const searchList = (params) => {
    return request.jsonp(originSumfsHost + '/sumis-web/union/sums/promotion/private/searchList.do', params)
}

/** 
 * @description PC选品库条件搜索商品
 */
export const batchAddCommodity = (params) => {
    return request.jsonp(originSumfsHost + '/sumis-web/selectCommodityLibrary/private/batchAddCommodity.do', params)
}

